<template>
  <div
    class="card-condition connection-type"
    :class="{ 'card-condition__planLimits': hasPlanLimitsRestriction('visitCapCondition') }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('visitCapCondition')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" icon="fas fa-times" size="12" class="card-condition__close"></ui-icon>

    <div class="label-wrapper">
      <ui-label class="mr-4" :text="t('Visits Cap')" />
      <ui-tooltip-icon preset="help">
        <span>
          {{ t('Visits limit counter works in UTC timezone.') }}<br />
          {{ t('Visits limit per hour means that an hours starts at 00 min and finishes in 00 min of the next hour.') }}<br />
          {{ t('Visits limit for 24 hours: starts at 00:00 of the first day and finishes at 00:00 of the next day.') }}<br />
          {{ t('Visits limit for a month: starts in the first day of month at 00:00 and finishes in the first day of the following month at 00:00.') }}
        </span>
      </ui-tooltip-icon>
    </div>

    <ui-info class="mb-8">
      {{ t('Specify the limit of visits on the required offer. After the limit is reached the traffic will be redirected to the default path.') }}
    </ui-info>

    <div class="d-flex flex-column">
      <div class="option-row">
        <ui-checkbox v-model="enabled.perHour" class="pb-0" />
        <ui-count-input v-model="value.perHour" :min="0" :disabled="!enabled.perHour" class="mr-6" />
        <ui-label class="text-lowercase" :text="t('For 1 hour')" />
      </div>
      <div class="option-row">
        <ui-checkbox v-model="enabled.perDay" class="pb-0" />
        <ui-count-input v-model="value.perDay" :disabled="!enabled.perDay" :min="0" class="mr-6" />
        <ui-label class="text-lowercase" :text="t('For 24 hours')" />
      </div>
      <div class="option-row">
        <ui-checkbox v-model="enabled.perMonth" class="pb-0" />
        <ui-count-input v-model="value.perMonth" :disabled="!enabled.perMonth" :min="0" class="mr-6" />
        <ui-label class="text-lowercase" :text="t('For 1 month')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFlowVisitCapCondition } from './useFlowVisitCapCondition';

const props = defineProps<{
  conditions: Record<string, {
    id: string;
    predicate: string;
    values: Record<string, number>;
  }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  value,
  enabled,
  hasPlanLimitsRestriction,
} = useFlowVisitCapCondition(props.conditions);
</script>

<style lang="scss" scoped>
.option-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.label-wrapper {
  display: flex;
  justify-content: flex-start;
}
</style>
